if (!customElements.get('evisia-product-details')) {
  customElements.define('evisia-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const source = this.querySelector('[data-source]');
      if (!source) return;
      const originalText = source.textContent.replace(/\s+/g, '');
      const backup = source.cloneNode(true);
      const destinations = Object.fromEntries(['information', 'usage', 'ingredients', 'brand'].map(key => [key, this.querySelector(`[data-content="${key}"]`)]));
      const normalize = text => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      const kind = text => {
        const title = normalize(text);
        if (/^(hoe\b|gebruik\b|gebruiksaanwijzing\b|toepassing\b|aanbrengen\b|how to\b|directions\b)/.test(title)) return 'usage';
        if (/^(bevat\b|ingredienten\b|ingredients\b|inci\b|samenstelling\b)/.test(title)) return 'ingredients';
        if (/^(over het merk\b|over [\w.& -]+\b|about the brand\b)/.test(title)) return 'brand';
        return 'information';
      };
      const heading = node => {
        if (node.nodeType !== 1) return null;
        if (/^H[2-6]$/.test(node.tagName)) return node.textContent;
        if (node.tagName === 'P' && node.children.length === 1 && /^(STRONG|B)$/.test(node.children[0].tagName) && node.textContent.trim() === node.children[0].textContent.trim()) return node.textContent;
        return null;
      };
      let benefitList;
      for (const node of source.querySelectorAll('ul')) {
        const previous = node.previousElementSibling;
        if (previous && /waarom|voordelen|kenmerken|eigenschappen|benefits|features/i.test(previous.textContent) && node.children.length >= 3) {
          benefitList = node;
          break;
        }
      }
      if (!benefitList) benefitList = Array.from(source.querySelectorAll('ul')).find(node => node.children.length >= 3 && !node.querySelector('[class*="icon-"]') && !/in de bundel|in deze set|inhoud van/i.test(node.previousElementSibling?.textContent || ''));
      if (benefitList) {
        const items = Array.from(benefitList.children).filter(node => node.tagName === 'LI').slice(0, 3).map(node => node.cloneNode(true));
        if (items.length === 3) {
          const list = this.querySelector('[data-benefits-list]');
          items.forEach(node => node.removeAttribute('id'));
          list.replaceChildren(...items);
          list.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        }
      }
      const fragment = document.createDocumentFragment();
      while (source.firstChild) fragment.append(source.firstChild);
      let current = 'information';
      for (const node of Array.from(fragment.childNodes)) {
        const title = heading(node);
        if (title !== null) current = kind(title);
        if (node.nodeType === 1 && node.tagName === 'P' && node.querySelector('br') && node.querySelector('strong, b')) {
          const lines = [];
          let line = document.createElement('p');
          for (const child of Array.from(node.childNodes)) {
            if (child.nodeType === 1 && child.tagName === 'BR') {
              lines.push(line);
              line = document.createElement('p');
            } else line.append(child);
          }
          lines.push(line);
          let lineDestination = current;
          for (const part of lines) {
            const label = part.querySelector('strong, b');
            if (label) {
              const target = kind(label.textContent);
              lineDestination = target === 'information' ? current : target;
            }
            destinations[lineDestination].append(part);
          }
        } else {
          const lead = node.nodeType === 1 && node.tagName === 'P' ? node.firstElementChild : null;
          const hasLeadingLabel = lead && /^(STRONG|B)$/.test(lead.tagName) && node.textContent.trim().startsWith(lead.textContent.trim());
          const target = hasLeadingLabel ? kind(lead.textContent) : current;
          destinations[target === 'information' ? current : target].append(node);
        }
      }
      const transformedText = Object.values(destinations).map(node => node.textContent).join('').replace(/\s+/g, '');
      const characterCounts = text => Array.from(text).sort().join('');
      if (characterCounts(originalText) !== characterCounts(transformedText)) {
        Object.values(destinations).forEach(node => node.replaceChildren());
        source.replaceChildren(...Array.from(backup.childNodes));
      }
      const hasUsage = destinations.usage.textContent.trim() || destinations.usage.querySelector('img, video, iframe, table');
      this.querySelector('[data-usage-note]').hidden = Boolean(hasUsage);
      this.dataset.ready = 'true';
    }
  });
}
